module.exports = __webpack_public_path__ + "static/img/img-2.dd7f44d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img-2.png
// module id = Z5oc
// module chunks = 10